export const formatNumber = (value, maximumFractionDigits = 2) => {
  if (isNaN(value) || value === null) {
    return ''
  }

  return value.toLocaleString('id-ID', { maximumFractionDigits })
}

export const formatOrDash = (value, maximumFractionDigits = 2, divisor = 1) => {
  const num = Number(value)

  if (value === null || value === undefined || isNaN(num)) {
    return '-'
  }

  const result = num / divisor

  return result.toLocaleString('id-ID', { maximumFractionDigits })
}

export const formatNumberTruncate = (
  value,
  maximumFractionDigits = 2,
  useComma = true,
  returnNumber = false
) => {
  if (isNaN(value) || value === null) return ''

  const num = Number(value)
  const factor = Math.pow(10, maximumFractionDigits)
  const truncated = Math.trunc(num * factor) / factor

  if (returnNumber) return truncated

  const locale = useComma ? 'id-ID' : 'en-US'

  return truncated.toLocaleString(locale, {
    maximumFractionDigits,
  })
}
